export default {
    msg: {
        diary: 'Дневник',
        help: 'Помощь',
        plan: 'План',
        note: 'Заметка',
        finance: 'Финансы',
        loginAuth: 'Вход',
        login: 'Войти',
        password: 'Пароль',
        registration: 'Регистрация',
        repeatPassword: 'Пароль еще раз',
        register: 'Зарегистрироваться',
        name: 'Название',
        loginName: 'Логин',
        projects: 'Проекты',
        add: 'Добавить',
        createProject: 'Создание проекта',
        editProject: 'Редактирование проекта',
        create: 'Создание',
        description: 'Описание',
        tags: 'Теги',
        save: 'Сохранить',
        toCreate: 'Создать',
        actions: 'Действия',
        edit: 'Редактирование',
        tasks: 'Задачи',
        tasksOfProject: 'Задачи проекта',
        status: 'Статус',
        createTask: 'Создание задачи',
        editTask: 'Редактирование задачи',
        notes: 'Заметки',
        time: 'Время',
        type: 'Тип',
        date: 'Дата',
        dayWeek: 'День недели',
        dayOfMonth: 'День месяца',
        month: 'Месяц',
        createNote: 'Создание заметки',
        editNote: 'Редактирование заметки',
        createAndAddTime: 'Создать и добавить время',
        createAndAddList: 'Создать и добавить список',
        list: 'Список',
        transactions: 'Транзакции',
        accounts: 'Счета',
        groups: 'Группы',
        today: 'Сегодня',
        yesterday: 'Вчера',
        lastDay: 'Последние 2 дня',
        lastWeek: 'Последняя неделя',
        lastMonth: 'Последний месяц',
        thisMonth: 'Этот месяц',
        previousMonth: 'Предыдущий месяц',
        dates: 'Даты',
        account: 'Счет',
        group: 'Группа',
        incomeExpenses: 'Доходы/Расходы',
        overallBalance: 'Общей баланс',
        accountBalance: 'Баланс счета',
        createTransaction: 'Создание транзакции',
        editTransaction: 'Редактирование транзакции',
        sum: 'Сумма',
        addTransaction: 'Добавить транзакцию',
        addTransfer: 'Добавить перевод',
        deleteQuestion: 'Удалить?',
        transfer: 'Перевод',
        createTransfer: 'Создание перевода',
        fromAccount: 'С счета',
        toAccount: 'На счет',
        balance: 'Баланс',
        currency: 'Валюта',
        in: 'в',
        createAccount: 'Создание счета',
        editAccount: 'Редактирование счета',
        incomeExpensesPerPeriod: 'Доход/Расход за период',
        monthLimit: 'Месечный лимит',
        createGroup: 'Создание группы',
        editGroup: 'Редактирование группы',
        monthlyLimitCurrency: 'Валюта месяного лимита',
        thereAreOutstandingSubTasks: 'Есть невыполненные подзадачи',
        addSubtask: 'Добавить подзадачу',
        addDateAndTime: 'Добавить дату и время',
        addingDateAndTime: 'Добавление даты и времени',
        subTasks: 'Подзадачи',
        isArchive: 'Архивировать',
        remove: 'Удалить',
        filter: 'Фильтр',
        progress: 'Прогресс',
        yes: 'Да',
        no: 'Нет',
        isDone: 'Выполнено',
        day: 'день',
        Day: 'День',
        comments: 'Комментарии',
        addComment: 'Добавить комментарий',
        cancel: 'Отменить',
        send: 'Отправить',
        projectDairy: 'Дневник проекта',
        thereAreNoTasksInTheProjectYet: 'Проекте еще нет задач',
        addLine: "Добавить строку",
        feed: "Лента",
        "followTheProgressOfPeople": "Следите за прогрессом людей",
        "subscriptions": "Подписки",
        "numberDaysFromStartTarget": "Количество дней от начала цели",
        "projectName": "Название проекта",
        "targets": "Цели",
        "total": "Всего",
        "done": "Выполнено",
        "dateExpiredNeedReconsider": "Дата истекла, нужно пересмотреть цель",
        "toDay": "Сегодня",
        "createTarget": "Создание цели",
        "editTarget": "Редактирование цели",
        "addImage": "Добавить картинку",
        "noRecords": "Нет записей",
        "toArchive": "В архив",
        "archive?": "Убрать в архив?",
        "dateStart": "Дата начало",
        "dateEnd": "Дата окончания",
        "weeklyPlan": "План на неделю",
        "monthlyPlan": "План на месяц",
        "project": "Проект",
        "task": "Задача",
        "approximateDuration": "Примерная продолжительность",
        "hours": "Часы",
        "minutes": "Минуты",
        "oneOfFieldsMustBeFilled": "одно из полей надо заполнить",
        "or": "или",
        "markRelatedTask": "Пометить связанную задачу",
        "start": "Начало",
        "end": "Окончание",
        "datesIntersect": "даты перекрываются с существующей записью",
        "h": "ч",
        "m": "м",
        "inArchive": "В архиве",
        "additionalSettings": "Дополнительные настройки",
        "parentTask": "Родительская задача",
        "createACopy": "Создать копию",
        "copyCreatedAndOpened": "Копия создана и открыта",
        "delete": "Удалить",
        "recordDeleted": "Запись удалена",
        "postponeForTomorrow": "Отложить на завтра",
        "postponedUntilTomorrow": "Отложено на завтра",
        "dailyReport": "Дневной отчет",
        "addImages": "Добавить картинки",
        "language": "Язык",
        "recoveryPassword": "Восстановить пароль",
        "emailConfirmedSuccessfully": "Email успешно подтвержден",
        "furtherInstructionsSentEmail": "Дальнейшие инструкции отправлены на email",
        "recovery": "Восстановить",
        "newPassword": "Новый пароль",
        "passwordSaved": "Пароль сохранен",
        "color": "Цвет",
        "profile": "Профиль",
        "yourPersonalData": "Ваши персональные данные",
        "email": "Email",
        "timezone": "Временная зона",
        "changePassword": "Изменение пароля",
        "oldPassword": "Старый пароль",
        "change": "Изменить",
        "passwordChanged": "Пароль изменен",
        "sumFromAccount": "Сумма со счета",
        "sumToAccount": "Сумма на счет",
        "highlightingTags": "Подсветка тегов",
        "curator": "Куратор",
        "message": "Сообщение",
        "pushNotification": "PUSH уведомления",
        "subscribe": "Подписаться",
        "subscribed": "Подписано",
        "reminders": "Напоминания",
        "remindersFromTasksForThisDay": "Напоминания из задач на этот день",
        "addToDayPlan": "Добавить в дневной план",
        "reminderAt": "Напоминание на",
        "logout": "Выйти",
        "planOnDay": "План на день",
        "week": "Неделя",
        "addingTask/ReportForDay": "Добавление задачи/отчета на день",
        "editingTask/ReportForDay": "Изменение задачи/отчета на день",
        "addingTaskForWeek": "Добавление задачи на неделю",
        "editingTaskForWeek": "Изменение задачи на неделю",
        "addingTaskForMonth": "Добавление задачи на месяц",
        "editingTaskForMonth": "Изменение задачи на месяц",
        "transferTasksToDailyPlan": "Перенос задач в дневной план",
        "transferTasksToWeeklyPlan": "Перенос задач в недельный план",
        "transferTasksToMonthlyPlan": "Перенос задач в месячный план",
        "fromWeekly": "Из недельного",
        "fromMonthly": "Из месячного",
        "fromProjects": "Из проектов",
        "ofPlan": "плана",
        "toTasksOfProject": "К задачам проекта",
        "addingTarget": "Добавление цели",
        "editingTarget": "Редактирование цели",
        "income": "Доход",
        "expenses": "Расход",
        "apply": "Применить",
        "clear": "Очистить",
        "close": "Закрыть",
        "other": "Разное",
        "articles": "Статьи",
        "immediateTargets": "Ближайшие цели",
        "yearTc": "лет | год | года | лет",
        "monthTc": "месяцев | месяц | месяца | месяцев",
        "weekTc": "недель | неделя | недели | недель",
        "dayTc": "дней | день | дня | дней",
        "toTarget": "До цели",
        "report": "Отчет",
        "projectReport": "Отчет проекта",
        "isCompleteds": "Выполненые",
        "showHours": "Показывать часы",
        "withoutTask": "Без задачи",
        "filter/sorting": "Фильтер/Сортировка",
        "sorting": "Сортировать",
        "byTime": "По времени",
        "byTask": "По задачам",
        "byAsc": "По возрастанию",
        "byDesc": "По убыванию",
        "sortType": "Тип сортировки",
        "back": "Назад",
        "reportByTasks": "Отчет по задачам",
        "monthBudget": "Месячный бюджет",
        "oneRecord": "одну запись",
        "transferFrom": "перенести из",
        "otherMonth": "другого месяца",
        "amount": "Сумма",
        "addAnotherCurrency": "Добавить другую валюту",
        "toTransfer": "Перенести",
        "foundRecords": "Найдено записей",
        "pcs": "шт",
        "fact": "Факт",
        "ignoreInMonthlyBudget": "Не учитывать в месячном бюджете",
        "toMonthlyBudget": "К месячному бюджету",
        "by": "до",
        "textColor": "Цвет текста",
        "completeTo": "Выполнить до",
        "addReminder": "Добавить напоминание",
        "publishTarget": "Публичная цель",
        "youHaveSuccessfullyRegistered": "Вы успешно зарегистрировались",
        "loginLinkHasBeenSentTo": "Ссылка для входа отправлена на адрес",
        "openMail": "Открыть почту",
        "tetheredDevices": "Привязанные устройства",
        "subscriptionEnded": "Закончилась подписка",
        "renewYourSubscription": "Продлить подписку",
        "subscription": "Подписка",
        "lastDayOfSubscription": "Последний день подписки",
        "noActiveSubscription": "Нет активной подписки",
        "subscriptionPackages": "Покеты подписки",
        "sale": "Скидка",
        "pay": "Оплатить",
        "tryForFree": "Попробовать бесплатно",
        "chatWithCurator": "Чат с куратором",
        "dayPlan": "Дневной план",
        "weekPlan": "Недельный план",
        "monthPlan": "Месячный план",
        "planning": "Планирование",
        "billing": "Биллинг",
        "paymentError": "Ошибка оплаты",
        "tryAgain": "Попробовать снова",
        "processingPayment": "Обработка платежа",
        "successfulPayment": "Успешная оплата",
        "inDiary": "В ежедневник",
        "everyMorningTasksForDay": "Каждое утро, задачи на день",
        "everyMorningComingTargets": "Каждое утро, ближайшие цели",
        "connectTelegramBot": "Подключить Telegram бота",
        "telegramBot": "Телеграм бот",
        "markers": "Маркеры",
        "toOther": "В разное",
        "pageDoesNotExist": "Страница не существует",
        "toMain": "На главную",
        "my": "Мои",
        "openTargetsChart": "Открыть график целей",
        "closeTargetsChart": "Закрыть график целей",
        "targetDiary": "Дневник цели",
        "publicTarget": "Публичная цель",
        "unaccountedBudget": "Неучтенный бюджет",
        "personalDataSaved": "Персональные данные сохранены",
        "mailConfirmed": "Почта подтверждена",
        "continue": "Продолжить",
        "mailConfirmationError": "Ошибка подтверждения почты",
        "confirmEmail": "Подтвердить почту",
        "linkSentToEmail": "Ссылка отправлена на почту",
        "confirmEmailRecoverPassword": "Подтвердите почту, это понадобится для восстановления пароля.",
        "errorLoginToSupport": "Если не получается войти в сервис, обратитесь в техподдержку.",
        "perMonth": "В месяц",
    },
    validation: {
        messages: {
            _default: 'не валидно',
            required: 'обязательное поле',
            required_if: 'обязательное поле',
            max: 'максимальная длина {1}',
            url: 'URL не валидный',
            decimal: 'не десятичное',
            numeric: 'не числовое',
            min_value: 'минимальное значение {1}',
            max_value: 'максимальное значение {1}',
            char_name: 'доступные символы: a-z A-Z 0-9 - _ .',
            repeat_password: 'пароли не совпадают',
            date_order: 'дата оканчания должна быть после даты начала',
            datetime_order: 'дата оканчания должна быть после даты начала',
            datetime_both: 'заполните оба поля',
            min: 'минимальная длина {1}',
            uniq_currency_id: 'нельзя выбрать одинаковые валюты'
        }
    },
    $vuetify: {
        dataTable: {
            itemsPerPageText: 'Строк на стр.',
            ariaLabel: {
                sortNone: 'Sort none',
                sortAscending: 'Sort ascending',
                sortDescending: 'Sort descending',
                activateAscending: 'Активируйте для упорядочивания по возрастанию.',
                activateDescending: 'Активируйте для упорядочивания убыванию.'
            }
        },
        dataFooter: {
            pageText: '{0}-{1} из {2}',
            itemsPerPageAll: 'Все',
            prevPage: 'Назад',
            nextPage: 'Вперед'
        },
        dataIterator: {
            loadingText: 'Загрузка...'
        },
        noDataText: 'Нет данных',
        datePicker: {
            itemsSelected: '{0} selected'
        }
    },
    txt: {
        project: {
            recordPlans: 'Все планы должны быть записаны. Не держите их в голове.',
            projectDairy: 'Ведите дневник цели. Можете опубликовать этот дневник цели, и другие пользователи смогу изучить его и комментировать.'
        },
        target: {
            recordTargets: 'Запишите свои цели. Так вы будете видеть свой вектор движения.'
        },
        note: {
            desc: 'Заметки и списки всегда под рукой'
        },
        finance: {
            desc: 'Планирование и учет финансов',
            infoSum: 'В итого не учитываются переводы'
        }
    },
    status: {
        new: 'Новое',
        in_work: 'В работе',
        done: 'Выполнено'
    },
    timeType: {
        one: 'Один раз',
        every_day: 'Каждый день',
        every_week: 'Каждую неделю',
        every_month: 'Каждый месяц',
        every_year: 'Каждый год'
    },
    dayOfWeek: {
        1: 'Понедельник',
        2: 'Вторник',
        3: 'Среда',
        4: 'Четверг',
        5: 'Пятница',
        6: 'Суббота',
        7: 'Воскресенье'
    },
    month: {
        1: 'Январь',
        2: 'Фервраль',
        3: 'Март',
        4: 'Апрель',
        5: 'Май',
        6: 'Июнь',
        7: 'Июль',
        8: 'Август',
        9: 'Сентябрь',
        10: 'Октябрь',
        11: 'Ноябрь',
        12: 'Декабрь'
    },
    monthName: {
        "January": "январь",
        "February": "февраль",
        "March": "март",
        "April": "апрель",
        "May": "май",
        "June": "июнь",
        "July": "июль",
        "August": "август",
        "September": "сентябрь",
        "October": "октябрь",
        "November": "ноябрь",
        "December": "декабрь",
    },
    monthShort: {
        "January": "янв",
        "February": "фев",
        "March": "мар",
        "April": "апр",
        "May": "май",
        "June": "июн",
        "July": "июл",
        "August": "авг",
        "September": "сен",
        "October": "окт",
        "November": "ноя",
        "December": "дек",
    },
    monthNameNum: {
        "January": "января",
        "February": "февраля",
        "March": "марта",
        "April": "апреля",
        "May": "мая",
        "June": "июня",
        "July": "июля",
        "August": "августа",
        "September": "сентября",
        "October": "октября",
        "November": "ноября",
        "December": "декабря",
    },
    week: {
        "Monday": "понедельник",
        "Tuesday": "вторник",
        "Wednesday": "среда",
        "Thursday": "четверг",
        "Friday": "пятница",
        "Saturday": "суббота",
        "Sunday": "воскресенье"
    },
    typeTransaction: {
        income: 'доход',
        expenses: 'расход',
        transfer: 'перевод'
    },
    filter: {
        is_done: 'Выполнено',
        is_archive: 'В архиве',
        tags: 'Маркеры',
        is_follow: 'Подписки',
        "type": "Тип",
        "date_start": "Дата от",
        "date_end": "Дата до",
        "account": "Счет",
        "group": "Группа",
        "is_completed": "Выполненные",
        "show_hours": "Показывать часы",
        "sort_by": "Сортировать",
        "sort_type": "Тип сортировки",
        "month": "Месяц"
    },
    "apiError": {
        "wrongPassword": "неправильный пароль",
        "invalidEmailOrPassword": "неправильный email или пароль",
        "loginHasAlready": "этот логин занят",
        "emailHasAlready": "пользователь с таким email уже зарегистрирован"
    }
}
